module.exports = require("ajv/lib/refs/json-schema-draft-07.json");